function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, displayDisclaimer) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'has-banner': displayDisclaimer
        }, {
          'workspace-disclaimer-wrapper': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((displayDisclaimer) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'workspace-disclaimer': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-banner", {
              "attrs": {
                'header-text': `Your data is being filtered`,
                'body-text': `This workspace (${$attr(`workspace-name`)}) has a filter applied and contains a subset of all data.`,
                cta: JSON.stringify({
                  trackEventName: `[Workspaces] Dismiss Banner`,
                  text: 'Dismiss',
                  actionName: 'dismiss',
                }),
              },
              "on": {
                action: $helpers.handleDisclaimerBannerAction
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "displayDisclaimer" in locals ? locals.displayDisclaimer : typeof displayDisclaimer !== "undefined" ? displayDisclaimer : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;